/*
 * Filename: clients.js
 * By: J. Nguyen
 * Date: 7/1/21
 *
 * Description: 
 * This template will be used for page specific logic for the clients page.
 *
 */


import CaseStudyCards from '../modules/case-study-cards';

const defaults = {             
  debugMode: false
}


init();
 
// initilize the module
function init() {
  
  CaseStudyCards();

}


// Basic debug function
function debug(msg) { 
  if (defaults.debugMode) {
    console.log(msg);
  }
}

